import { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';
import { getCampaignTileImagePath, normalizeRecordId } from '@/helpers/marketing/campaignTileImagePath.js';

export const useCampaignTileImage = (recordId, cacheKey) => {
    const dataProvider = useDataProvider();
    const normalizedId = normalizeRecordId(recordId);
    const [imageUrl, setImageUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(Boolean(normalizedId));
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (!normalizedId) {
            setImageUrl(null);
            setIsLoading(false);
            setHasError(false);
            return undefined;
        }

        let isCancelled = false;
        let objectUrl = null;
        const imagePath = getCampaignTileImagePath(normalizedId, cacheKey);

        setIsLoading(true);
        setHasError(false);
        setImageUrl(null);

        dataProvider
            .getOptionalBlob(imagePath)
            .then(blob => {
                if (isCancelled) {
                    return;
                }

                if (!blob) {
                    setHasError(true);
                    return;
                }

                objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
            })
            .catch(() => {
                if (!isCancelled) {
                    setHasError(true);
                }
            })
            .finally(() => {
                if (!isCancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            isCancelled = true;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [normalizedId, cacheKey, dataProvider]);

    return { imageUrl, isLoading, hasError };
};
